<div class="di-menu-groupe-journee">
  <lua-list-item text="Modifier l'evenement" iconName="edit"  (click)="modifEvent($event)" ></lua-list-item>
  <lua-list-item text="Supprimer l'évènement" iconName="delete" iconColor="Error" (click)="deleteEvent($event)" ></lua-list-item>
</div>